<template>
  <div>
    <main v-cloak>
      <!-- <figure class="about-img2 img-wrapper">
			<img src="../../assets/static/images/illustrations/ecommerce.svg" />
			</figure> -->
      <p style="margin:0;">
        <button
          data-qa="stepByStepGuideButton"
          class="login-btn"
          @click="toggleModal()"
        >
          {{ $t('instructionsButton') }}
        </button>
      </p>
      <!--  The Modal -->
      <boardal
        v-if="modal.isOpen"
        :has-mask="modal.hasMask"
        :can-click-mask="modal.canClickMask"
        :has-x="modal.hasX"
        @toggle="toggleModal"
      >
        <article v-cloak>
          <section>
            <button class="bg close-btn" @click="finish()">&#10006;</button>
            <br />
            <h3 data-qa="companyDetailsTitle">{{ $t('addCompanyDetails') }}</h3>
            <br />
            <div class="about-container">
              <figure class="about-img img-wrapper">
                <img
                  class="sm-img"
                  src="../../assets/static/images/illustrations/company.svg"
                />
              </figure>
              <div class="about-text">
                <div>
                  <!-- <label>{{ $t('companyName') }}</label> -->
                  <input
                    v-model="name"
                    class="field inp"
                    :class="{ errorBg: $v.name.$error }"
                    type="text"
                    name="name"
                    maxlength="50"
                    @blur="$v.name.$touch()"
                    v-on:input="isValidData"
                    :placeholder="$t('companyName')"
                    data-qa="companyNameInput"
                  />
                  <template v-if="$v.name.$error">
                    <p v-if="!$v.name.required" class="errorMessage">
                      {{ $t('companyNameReq') }}
                    </p>
                  </template>
                </div>

                <div>
                  <input
                    v-model="address"
                    class="field inp"
                    :class="{ errorBg: $v.address.$error }"
                    type="text"
                    name="address"
                    maxlength="30"
                    @blur="$v.address.$touch()"
                    v-on:input="isValidData"
                    :placeholder="$t('companyAddress')"
                    data-qa="companyAddressInput"
                  />
                  <template v-if="$v.address.$error">
                    <p v-if="!$v.address.required" class="errorMessage">
                      {{ $t('addressReq') }}
                    </p>
                  </template>
                </div>

                <div>
                  <input
                    v-model="address_no"
                    class="field inp"
                    :class="{ errorBg: $v.address_no.$error }"
                    type="text"
                    name="address_no"
                    maxlength="30"
                    @blur="$v.address_no.$touch()"
                    v-on:input="isValidData"
                    :placeholder="$t('companyAddressNo')"
                    data-qa="companyAddressNoInput"
                  />
                  <template v-if="$v.address_no.$error">
                    <p v-if="!$v.address_no.required" class="errorMessage">
                      {{ $t('addressNoReq') }}
                    </p>
                  </template>
                </div>

                <div>
                  <b-button
                    class="questionMark questionMarkLeft"
                    v-b-tooltip.hover
                    :title="$t('buildingNoTooltip')"
                    >?</b-button
                  >
                  <input
                    v-model="building_no"
                    class="fieldZipCode inp"
                    :class="{ errorBg: $v.building_no.$error }"
                    type="number"
                    maxlength="10"
                    name="building_no"
                    @blur="$v.building_no.$touch()"
                    v-on:input="isValidData"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                    :placeholder="$t('buildingNo')"
                    data-qa="buildingNoInput"
                  />

                  <template v-if="$v.building_no.$error">
                    <p v-if="!$v.building_no.required" class="errorMessage">
                      {{ $t('buildingNoReq') }}
                    </p>
                  </template>
                </div>

                <div class="price-wrapper">
                  <div>
                    <input
                      v-model="postal_code"
                      class="field fieldZipCode inp"
                      :class="{ errorBg: $v.postal_code.$error }"
                      type="text"
                      name="postal_code"
                      maxlength="10"
                      @blur="$v.postal_code.$touch()"
                      v-on:input="isValidData"
                      :placeholder="$t('postalCode')"
                      data-qa="postalCodeInput"
                    />
                    <template v-if="$v.postal_code.$error">
                      <p v-if="!$v.postal_code.required" class="errorMessage">
                        {{ $t('postalCodeReq') }}
                      </p>
                    </template>
                  </div>
                </div>

                <div>
                  <multiselect
                    v-model="city"
                    :options="cityNames"
                    :searchable="true"
                    maxHeight="100"
                    :close-on-select="true"
                    :placeholder="$t('selectCity')"
                    :show-labels="true"
                    class="field fieldPrice2 inp"
                    :class="{ errorBg: $v.city.$error }"
                    @input="changeCity()"
                    @blur="$v.city.$touch()"
                    data-qa="cityDropdown"
                  ></multiselect>
                  <template v-if="$v.city.$error">
                    <p v-if="!$v.city.required" class="errorMessage">
                      {{ $t('cityReq') }}
                    </p>
                  </template>
                </div>

                <div>
                  <b-button
                    class="questionMark questionMarkLeft marginBottom"
                    v-b-tooltip.hover
                    :title="$t('KOTooltip')"
                    >?</b-button
                  >
                  <multiselect
                    v-model="region"
                    :options="regionNames"
                    :searchable="true"
                    maxHeight="100"
                    :close-on-select="true"
                    :placeholder="$t('selectRegion')"
                    :show-labels="false"
                    class="field fieldPrice2 inp"
                    :class="{ error: $v.region.$error }"
                    @input="changeRegion()"
                    @blur="$v.region.$touch()"
                    data-qa="regionDropdown"
                  ></multiselect>
                  <template v-if="$v.region.$error">
                    <p v-if="!$v.region.required" class="errorMessage">
                      {{ $t('regionReq') }}
                    </p>
                  </template>
                </div>

                <div>
                  <country-select
                    v-model="country"
                    :country="country"
                    class="field fieldZipCode inp"
                    topCountry="SI"
                    :countryName="true"
                    :autocomplete="true"
                    :removePlaceholder="true"
                    :usei18n="false"
                    @blur="$v.unit.country.$touch()"
                    data-qa="countryDropdown"
                  />
                </div>
                <br />
                <div>
                  <input
                    v-model="vat_no"
                    class="field fieldZipCode inp"
                    :class="{ errorBg: $v.vat_no.$error }"
                    type="number"
                    minlength="8"
                    maxlength="8"
                    @blur="$v.vat_no.$touch()"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                    v-on:input="isValidData"
                    :placeholder="$t('vatNo')"
                    data-qa="vatNoInput"
                  />
                  <template v-if="$v.vat_no.$error">
                    <p v-if="!$v.vat_no.required" class="errorMessage">
                      {{ $t('vatNoReq') }}
                    </p>
                  </template>
                  <template v-if="$v.vat_no.$error">
                    <p v-if="!$v.vat_no.minLength" class="errorMessage">
                      {{ $t('companyVatNoLength') }}
                    </p>
                  </template>
                  <v-radio-group
                    id="liableForVAT"
                    inline
                    :label="$t('liableForVAT')"
                    v-model="liable_for_vat"
                  >
                    <v-radio :label="$t('no')" value="0"></v-radio>
                    <v-radio :label="$t('yes')" value="1"></v-radio>
                  </v-radio-group>
                </div>
              </div>
            </div>
          </section>
          <section>
            <button class="bg close-btn" @click="finish()">&#10006;</button>
            <br />
            <h3 data-qa="companyContactsTitle">
              {{ $t('addCompanyContacts') }}
            </h3>
            <figure class="about-img img-wrapper">
              <img src="../../assets/static/images/illustrations/support.svg" />
            </figure>
            <div class="about-text">
              <p data-qa="companyContactsText">
                {{ $t('contactDetails') }}
                <b-button
                  class="questionMark"
                  v-b-tooltip.hover
                  :title="$t('contactDetails?')"
                  >?</b-button
                >
              </p>
              <div>
                <label data-qa="emailLabel">{{ $t('email') }}</label>
                <input
                  v-model="email_general"
                  class="field inp"
                  :class="{ errorBg: $v.email_general.$error }"
                  type="email"
                  name="email_general"
                  maxlength="50"
                  @blur="$v.email_general.$touch()"
                  v-on:input="isValidData"
                  :placeholder="$t('emailExample')"
                  data-qa="emailInput"
                />
                <template v-if="$v.email_general.$error">
                  <p v-if="!$v.email_general.required" class="errorMessage">
                    {{ $t('emailGeneralReq') }}
                  </p>
                </template>
                <template v-if="$v.email_general.$error">
                  <p v-if="!$v.email_general.email" class="errorMessage">
                    {{ $t('emailValid') }}
                  </p>
                </template>
              </div>

              <div>
                <label data-qa="contactNumberLabel">{{
                  $t('contactNo')
                }}</label>
                <input
                  v-model="contact_no"
                  class="field inp"
                  :class="{ errorBg: $v.contact_no.$error }"
                  type="text"
                  name="contact_no"
                  maxlength="13"
                  @blur="$v.contact_no.$touch()"
                  v-on:input="isValidData"
                  :placeholder="$t('contactNoExample')"
                  data-qa="contactNumberInput"
                />
                <template v-if="$v.contact_no.$error">
                  <p v-if="!$v.contact_no.required" class="errorMessage">
                    {{ $t('contactNoReq') }}
                  </p>
                  <div v-else class="errorMessage">
                    {{ $t('contactRegexValidation') }}<br />
                  </div>
                </template>
              </div>
              <br />
              <div>
                <div
                  style="display: flex;align-items: flex-start;flex-direction: column;"
                >
                  <label data-qa="websiteLabel" style="margin: 0">{{
                    $t('website')
                  }}</label>
                  <div class="optional">{{ $t('optional') }}</div>
                </div>
                <input
                  v-model="website_url"
                  class="field inp"
                  :class="{ errorBg: $v.website_url.$error }"
                  type="url"
                  name="website_url"
                  maxlength="100"
                  :placeholder="$t('websiteExample')"
                  @blur="$v.website_url.$touch()"
                  v-on:input="isValidData"
                  data-qa="websiteInput"
                />
                <template v-if="$v.website_url.$error">
                  <div v-if="!$v.website_url.url" class="errorMessage">
                    {{ $t('validUrlReq') }}
                  </div>
                </template>
              </div>
            </div>
          </section>
          <section v-if="isProductFlowEnabled">
            <button class="bg close-btn" @click="finish()">&#10006;</button>
            <br />
            <h3 data-qa="unitsTitle">{{ $t('createUnit') }}</h3>
            <div class="about-container">
              <figure class="about-img img-wrapper">
                <img src="../../assets/static/images/illustrations/unit.svg" />
              </figure>
              <div data-qa="unitsText" class="about-text">
                <p>{{ $t('copyUnitDetails') }}</p>

                <div>
                  <label data-qa="unitNameLabel">{{ $t('unitName') }}</label>
                  <input
                    v-model="unitName"
                    class="field inp"
                    :class="{ errorBg: $v.unitName.$error }"
                    type="text"
                    name="unitName"
                    maxlength="50"
                    @blur="$v.unitName.$touch()"
                    v-on:input="isValidData"
                    :placeholder="$t('unitNameExample')"
                    data-qa="unitNameInput"
                  />
                  <template v-if="$v.unitName.$error">
                    <p v-if="!$v.unitName.required" class="errorMessage">
                      {{ $t('unitNameReq') }}
                    </p>
                  </template>
                </div>
                <br />
                <br />

                <div>
                  <label data-qa="unitAddressLabel">{{ $t('address') }}</label>
                  <input
                    v-model="unitAddress"
                    class="field inp"
                    id="unitAddress"
                    ref="autocomplete"
                    :class="{ errorBg: $v.unitAddress.$error }"
                    type="text"
                    name="unitAddress"
                    maxlength="100"
                    @blur="$v.unitAddress.$touch()"
                    v-on:input="isValidData"
                    :placeholder="$t('address')"
                    data-qa="unitAddressInput"
                  />
                  <template v-if="$v.unitAddress.$error">
                    <p v-if="!$v.unitAddress.required" class="errorMessage">
                      {{ $t('addressReq') }}
                    </p>
                  </template>
                </div>
                <br />
                <br />
                <!-- <div class="stockInput">
						<label>{{ $t('currentStock') }}</label>
						<b-button
							class="questionMark"
							v-b-tooltip.hover
							:title="$t('step6-mandatory6')"
							>?</b-button
						>
						<input
							v-model="stock_curr"
							class="fieldPrice inp"
							:class="{ errorBg: $v.stock_curr.$error }"
							type="number"
							name="stock_curr"
							@blur="$v.stock_curr.$touch()"
							v-on:input="isValidData"
							placeholder="50"
						/>
						<span>{{ $t('pcs') }}</span>
						<template v-if="$v.stock_curr.$error">
							<p v-if="!$v.stock_curr.required" class="errorMessage">
							{{ $t('currentStockReq') }}
							</p>
						</template>
						</div> -->
              </div>
            </div>
          </section>
          <section>
            <button class="bg close-btn" @click="finish()">&#10006;</button>
            <br />
            <h3 data-qa="stripeAccountTitle">{{ $t('addStripeKeys') }}</h3>
            <div class="about-container">
              <figure class="about-img img-wrapper">
                <a
                  href="https://dashboard.stripe.com/account/apikeys"
                  target="_blank"
                  ><img src="../../assets/static/images/stripe.png"
                /></a>
              </figure>
              <div class="about-text">
                <p data-qa="stripeAccountText">
                  {{ $t('copyLiveKeys') }}
                  <b-button
                    class="questionMark"
                    v-b-tooltip.hover
                    :title="$t('APIKeys?')"
                    >?</b-button
                  >
                </p>
                <div>
                  <label data-qa="stripePublicKeyLabel">{{
                    $t('publishKey')
                  }}</label>
                  <input
                    v-model="publish_key"
                    class="field inp"
                    :class="{ errorBg: $v.publish_key.$error }"
                    type="text"
                    name="publish_key"
                    @blur="$v.publish_key.$touch()"
                    v-on:input="isValidData"
                    :placeholder="$t('publishKeyExample')"
                    data-qa="stripePublicKeyInput"
                  />
                  <template v-if="$v.publish_key.$error">
                    <p v-if="!$v.publish_key.required" class="errorMessage">
                      {{ $t('publishKeyReq') }}
                    </p>
                  </template>
                  <div
                    v-if="this.errors"
                    class="errorMessage"
                    data-qa="keyAlreadyExist"
                  >
                    {{ this.errors }}
                  </div>
                </div>
                <br />
                <br />

                <div>
                  <label data-qa="stripeSecretKeyLabel">{{
                    $t('secretKey')
                  }}</label>
                  <b-button
                    class="questionMark"
                    v-b-tooltip.hover
                    :title="$t('secretKey?')"
                    >?</b-button
                  >
                  <input
                    v-model="secret_key"
                    class="field inp"
                    :class="{ errorBg: $v.secret_key.$error }"
                    type="text"
                    name="secret_key"
                    @blur="$v.secret_key.$touch()"
                    v-on:input="isValidData"
                    :placeholder="$t('secretKeyExample')"
                    data-qa="stripeSecretKeyInput"
                  />
                  <template v-if="$v.secret_key.$error">
                    <p v-if="!$v.secret_key.required" class="errorMessage">
                      {{ $t('secretKeyReq') }}
                    </p>
                  </template>
                </div>
                <br />
                <br />
              </div>
            </div>
            <FAQStripe />
            <br />
            <div>
              <a
                class="trash-btn"
                href="https://stripe.com/en-gb-si"
                target="_blank"
                data-qa="goToStripeButton"
              >
                {{ $t('goToStripe') }}
              </a>
            </div>
          </section>
          <section>
            <button class="bg close-btn" @click="finish()">&#10006;</button>
            <br />
            <!-- <ToggleServiceProduct  @type-changed="selectType"/> -->
            <h3 data-qa="categoriesTitle">{{ $t('connectCebelca') }}</h3>
            <div class="about-container">
              <br />
              <br />
              <TaxVerification source="FIRST_MODAL" @completeCebelcaStep="completeCebelcaStep" />
              <br />
              <p data-qa="categoriesText">{{ $t('whyConnectCebelca') }}</p>
            </div>
          </section>
          <section>
            <button class="bg close-btn" @click="finish()">&#10006;</button>
            <br />
            <!-- <ToggleServiceProduct  @type-changed="selectType"/> -->
            <h3 data-qa="categoriesTitle">{{ $t('selectProdCat') }}</h3>
            <div class="about-container">
              <br />
              <br />
              <CategoryCardSlider
                :isProductFlowEnabled="isProductFlowEnabled"
                @selected-category="selectedCategory"
                @unselected-category="unselectedCategory"
              />
              <br />
              <p data-qa="categoriesText">{{ $t('whySelectCategory') }}</p>
            </div>
          </section>
          <!-- <section>
					<button class="bg close-btn" @click="finish()">&#10006;</button>
					<h3>{{ $t('addSupplier') }}</h3>
					<div class="about-container">
					<br />
					<br />
					<SupplierCardSlider @supplier-selected="selectedSupplier" />
					<br />
					</div>
				</section> -->
          <section v-if="isProductFlowEnabled">
            <button class="bg close-btn" @click="finish()">&#10006;</button>
            <h3 data-qa="addProductTitle">{{ $t('addProduct') }}</h3>
            <div class="about-container">
              <figure class="about-img img-wrapper">
                <img
                  src="../../assets/static/images/illustrations/product.svg"
                />
              </figure>
              <div class="about-text">
                <div>
                  <label data-qa="productNameLabel">{{
                    $t('productName')
                  }}</label>
                  <input
                    v-model="productName"
                    class="field inp"
                    :class="{ errorBg: $v.productName.$error }"
                    type="text"
                    name="productName"
                    maxlength="35"
                    @blur="$v.productName.$touch()"
                    v-on:input="isValidData"
                    :placeholder="$t('prodNameExample')"
                    data-qa="productNameInput"
                  />
                  <template v-if="$v.productName.$error">
                    <p v-if="!$v.productName.required" class="errorMessage">
                      {{ $t('prodNameReq') }}
                    </p>
                  </template>
                </div>

                <div>
                  <label data-qa="productDescriptionLabel">{{
                    $t('prodDesc50')
                  }}</label>
                  <b-form-textarea
                    v-model="description"
                    class="field inp"
                    :class="{ errorBg: $v.description.$error }"
                    type="text"
                    name="description"
                    maxlength="300"
                    rows="4"
                    @blur="$v.description.$touch()"
                    v-on:input="isValidData"
                    :placeholder="$t('prodDescExample')"
                    data-qa="productDescriptionInput"
                  />
                  <template v-if="$v.description.$error">
                    <p v-if="!$v.description.required" class="errorMessage">
                      {{ $t('prodDescReq') }}
                    </p>
                  </template>
                </div>

                <div class="price-wrapper">
                  <div>
                    <label data-qa="sellingPriceLabel">{{
                      $t('sellingPrice')
                    }}</label>
                    <b-button
                      class="questionMark"
                      v-b-tooltip.hover
                      :title="$t('sellingPrice?')"
                      >?</b-button
                    >
                    <input
                      v-model="sellingPrice"
                      class="fieldPrice inp"
                      :class="{ errorBg: $v.sellingPrice.$error }"
                      type="number"
                      min="0.5"
                      step=".01"
                      name="sellingPrice"
                      @blur="$v.sellingPrice.$touch()"
                      v-on:input="isValidData"
                      placeholder="2.50"
                      data-qa="sellingPriceInput"
                    />
                    <span data-qa="sellingPriceCurrency"
                      >{{ selectedCurrency }}
                    </span>
                    <template v-if="$v.sellingPrice.$error">
                      <p v-if="!$v.sellingPrice.required" class="errorMessage">
                        {{ $t('sellingPriceReq') }}
                      </p>
                    </template>
                  </div>

                  <div>
                    <label data-qa="purchasePriceLabel">{{
                      $t('purchasePrice')
                    }}</label>
                    <b-button
                      class="questionMark"
                      v-b-tooltip.hover
                      :title="$t('purchasePrice?')"
                      >?</b-button
                    >
                    <input
                      v-model="purchasePrice"
                      class="fieldPrice inp"
                      type="number"
                      min="0"
                      step=".01"
                      name="purchasePrice"
                      placeholder="1.50"
                      v-on:input="isValidData"
                      data-qa="purchasePriceInput"
                    />
                    <span data-qa="purchasePriceCurrency">{{
                      selectedCurrency
                    }}</span>
                    <template v-if="$v.purchasePrice.$error">
                      <p v-if="!$v.purchasePrice.required" class="errorMessage">
                        {{ $t('purchasePriceReq') }}
                      </p>
                    </template>
                  </div>
                </div>
                <br />
                <div class="stockInput">
                  <label data-qa="stockLabel">{{ $t('stock') }}</label>
                  <b-button
                    class="questionMark"
                    v-b-tooltip.hover
                    :title="$t('stock_general?')"
                    >?</b-button
                  >
                  <input
                    v-model="stock_general"
                    class="fieldPrice inp"
                    :class="{ errorBg: $v.stock_general.$error }"
                    type="number"
                    name="stock_general"
                    @blur="$v.stock_general.$touch()"
                    placeholder="50"
                    v-on:input="isValidData"
                    data-qa="stockInput"
                  />
                  <span data-qa="stockItems">{{ $t('pcs') }}</span>
                  <template v-if="$v.stock_general.$error">
                    <p v-if="!$v.stock_general.required" class="errorMessage">
                      {{ $t('currentStockReq') }}
                    </p>
                  </template>
                </div>
                <br />
              </div>
            </div>
          </section>
          <section v-else>
            <button class="bg close-btn" @click="finish()">&#10006;</button>
            <h3>{{ $t('addExperience') }}</h3>
            <div class="about-container">
              <figure class="about-img img-wrapper">
                <img
                  src="../../assets/static/images/illustrations/product.svg"
                />
              </figure>
              <div class="about-text">
                <div>
                  <label>{{ $t('experienceName') }}</label>
                  <input
                    v-model="productName"
                    class="field inp"
                    :class="{ errorBg: $v.productName.$error }"
                    type="text"
                    name="productName"
                    maxlength="18"
                    @blur="$v.productName.$touch()"
                    v-on:input="isValidData"
                    :placeholder="$t('prodNameExample')"
                  />
                  <template v-if="$v.productName.$error">
                    <p v-if="!$v.productName.required" class="errorMessage">
                      {{ $t('expNameReq') }}
                    </p>
                  </template>
                </div>

                <div>
                  <label>{{ $t('expDesc50') }}</label>
                  <b-form-textarea
                    v-model="description"
                    class="field inp"
                    :class="{ errorBg: $v.description.$error }"
                    type="text"
                    name="description"
                    maxlength="300"
                    rows="4"
                    @blur="$v.description.$touch()"
                    v-on:input="isValidData"
                    :placeholder="$t('prodDescExample')"
                  />
                  <template v-if="$v.description.$error">
                    <p v-if="!$v.description.required" class="errorMessage">
                      {{ $t('expDescReq') }}
                    </p>
                  </template>
                </div>

                <div class="price-wrapper">
                  <div>
                    <label>{{ $t('minPrice') }}</label>
                    <input
                      v-model="minPrice"
                      class="fieldPrice inp"
                      :class="{ errorBg: $v.minPrice.$error }"
                      type="number"
                      min="0"
                      name="minPrice"
                      @blur="$v.minPrice.$touch()"
                      v-on:input="isValidData"
                      placeholder="1.50"
                    />
                    <span>{{ selectedCurrency }} </span>
                    <template v-if="$v.minPrice.$error">
                      <p v-if="!$v.minPrice.required" class="errorMessage">
                        {{ $t('priceRangeReq') }}
                      </p>
                    </template>
                  </div>

                  <div>
                    <label>{{ $t('maxPrice') }}</label>
                    <input
                      v-model="maxPrice"
                      class="fieldPrice inp"
                      type="number"
                      min="0"
                      name="maxPrice"
                      placeholder="2.50"
                      v-on:input="isValidData"
                    />
                    <span>{{ selectedCurrency }}</span>
                  </div>
                </div>
                <br />
                <div class="stockInput">
                  <label>{{ $t('url') }}</label>
                  <b-button
                    class="questionMark"
                    v-b-tooltip.hover
                    :title="$t('url?')"
                    >?</b-button
                  >
                  <input
                    v-model="urlReservation"
                    class="fieldPrice inp"
                    :class="{ errorBg: $v.urlReservation.$error }"
                    type="text"
                    name="stock_general"
                    @blur="$v.urlReservation.$touch()"
                    v-on:input="isValidData"
                    placeholder="www.test.com"
                  />
                  <template v-if="$v.urlReservation.$error">
                    <p v-if="!$v.urlReservation.required" class="errorMessage">
                      {{ $t('urlResReq') }}
                    </p>
                  </template>
                  <template v-if="$v.urlReservation.$error">
                    <p v-if="!$v.urlReservation.url" class="errorMessage">
                      {{ $t('validUrlReq') }}
                    </p>
                  </template>
                </div>
                <br />
              </div>
            </div>
          </section>
          <section v-if="isProductFlowEnabled">
            <button class="bg close-btn" @click="finish()">&#10006;</button>
            <br />
            <h3 data-qa="shippingTitle">{{ $t('shippingDetails') }}</h3>
            <br />
            <p data-qa="shippingText">{{ $t('offerGuestDelivery') }}</p>
            <div class="about-container">
              <DeliveryDetails @shipping-details="saveShippingData" />
            </div>
          </section>
          <section v-if="isProductFlowEnabled">
            <button class="bg close-btn" @click="finish()">&#10006;</button>
            <br />
            <h3 data-qa="wholesaleTitle">{{ $t('wholesaleDetails') }}</h3>
            <br />
            <p data-qa="wholesaleText">{{ $t('offerToOtherClients') }}</p>
            <div class="about-container">
              <WholesaleDetails @wholesale-details="saveWholesaleData" />
            </div>
          </section>
          <section>
            <button class="bg close-btn" @click="finish()">&#10006;</button>
            <br />
            <h3 data-qa="uploadImgTitle">{{ $t('allmostThere') }}</h3>
            <div class="about-container">
              <div>
                <p data-qa="uploadImgText">{{ $t('uploadMaterial') }}</p>
                <hr />
                <ProductImageUpload
                  :isProductFlowEnabled="isProductFlowEnabled"
                  :productId="productId"
                  :experienceId="experienceId"
                />
              </div>
            </div>
          </section>
          <section v-if="isProductFlowEnabled">
            <button class="bg close-btn" @click="finish()">&#10006;</button>
            <br />
            <h3 data-qa="finalStepTitle">{{ $t('success') }}</h3>
            <div class="about-container">
              <figure class="about-img img-wrapper">
                <img
                  src="../../assets/static/images/illustrations/QRscanning2.svg"
                />
              </figure>
              <div class="about-text">
                <div
                  @click="openQRCodeModal"
                  class="trash-btn"
                  data-qa="GetQrCodeButton"
                >
                  <font-awesome-icon class="icon" icon="qrcode" /><span>
                    {{ $t('getQRcode') }}</span
                  >
                </div>
                <br />
                <router-link
                  target="_blank"
                  :to="{
                    name: 'unitStore',
                    params: {
                      unitUUID: unitProduct.unit_uuid,
                      productUUID: unitProduct.product_uuid
                    }
                  }"
                >
                  <div class="trash-btn hideDesktop">
                    <font-awesome-icon
                      class="icon"
                      icon="shopping-basket"
                    /><span> {{ $t('visitShop') }}</span>
                  </div>
                </router-link>
              </div>
            </div>
          </section>
          <section v-else>
            <button class="bg close-btn" @click="finish()">&#10006;</button>
            <h3>{{ $t('success-exp') }}</h3>
            <div class="about-container">
              <figure class="about-img img-wrapper">
                <img
                  src="../../assets/static/images/illustrations/QRscanning2.svg"
                />
              </figure>
              <div class="about-text">
                <div @click="$bvModal.show('qrcode-modal')" class="trash-btn">
                  <font-awesome-icon class="icon" icon="qrcode" /><span>
                    {{ $t('getQRcode') }}</span
                  >
                </div>
                <br />
              </div>
            </div>
          </section>
        </article>
        <footer>
          <div class="forward-actions">
            <!--         <button class="secondary skip" :disabled="isLastStep" v-show="!isLastStep" @click="skip(2)">Skip</button> -->
            <button
              data-qa="nextButton"
              class="primary next"
              :disabled="!isDataValid || isLastStep"
              xv-show="isDataValid"
              @click="nextClick()"
            >
              <i class="fa fa-fw fa-lg" :class="nextIcon"></i>
            </button>
            <button
              class="accent save finishBtn"
              :disabled="!isLastStep"
              v-show="isLastStep"
              @click="finish"
              data-qa="ConfirmButton"
            >
              <i class="fa fa-fw fa-lg fa-check"></i>
            </button>
          </div>
          <div class="step-dots" v-if="hasDots">
            <div
              v-bind:key="n"
              class="step-dot"
              v-for="n in max"
              :class="{ active: n == step }"
              @click="goToStep(n)"
            ></div>
          </div>
          <div class="back-actions">
            <button
              data-qa="backButton"
              class="secondary cancel prev"
              :disabled="isFirstStep"
              xv-show="!isFirstStep"
              @click="skip(-1)"
            >
              <i class="fa fa-fw fa-lg" :class="backIcon"></i>
            </button>
          </div>
        </footer>
      </boardal>
    </main>
    <b-modal id="qrcode-modal" size="lg" body-class="hide-padding" hide-footer>
      <!-- <template v-slot:modal-title>
			</template> -->
      <div v-if="isProductFlowEnabled">
        <!-- <div id="textbox1">
					{{ baseUrl }}/unitStore/{{ unitProduct.unit_uuid }}/product/{{ unitProduct.product_uuid }}
				</div> -->
        <br />
        <div>
          <div id="qrcode" ref="qrcode"></div>
          <br />
          <div class="qr-details">
            <p>
              {{ $tc('unit', 1) }}: <strong>{{ unitName }}</strong>
            </p>
            <p>
              {{ $t('productName') }}: <strong>{{ productName }}</strong>
            </p>
            <p v-if="productCategory">
              {{ $t('productCat') }}:
              <strong>{{ productCategory.name }}</strong>
            </p>
          </div>
          <div class="trash-btn1" @click="downloadQRCodePdf">
            {{ $t('downloadPDF') }}
          </div>
        </div>
      </div>
      <div v-else>
        <div id="textbox1">{{ baseUrl }}/experience/{{ experience.uuid }}</div>
        <br />
        <div>
          <qrcode-vue
            id="qrcode"
            :value="`${baseUrl}/experience/${experience.uuid}`"
            size="100"
            level="H"
          ></qrcode-vue>
          <br />
          <div class="qr-details">
            <p>
              {{ $t('experienceName') }}: <strong>{{ productName }}</strong>
            </p>
            <p v-if="productCategory">
              {{ $t('experienceCat') }}:
              <strong>{{ productCategory.name }}</strong>
            </p>
          </div>
          <div class="trash-btn" @click="downloadExperienceQRCodePdf">
            {{ $t('downloadPDF') }}
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'
import {
  required,
  email,
  url,
  decimal,
  numeric,
  minLength,
  maxLength,
  helpers
} from 'vuelidate/lib/validators'
import boardal from '@/components/common/Boardal.vue'
import CategoryCardSlider from '@/components/common/CategoryCardSlider.vue'
import FAQStripe from '@/components/onboarding/FAQStripe.vue'
// import SupplierCardSlider from '@/components/common/SupplierCardSlider.vue'
import DeliveryDetails from '@/components/forms/DeliveryDetails.vue'
import WholesaleDetails from '@/components/forms/WholesaleDetails.vue'
import ProductImageUpload from '@/components/ui/ProductImageUpload.vue'
import TaxVerification from '@/pages/TaxVerification.vue'
// import ToggleServiceProduct from '@/components/common/ToggleServiceProduct.vue'
import * as QRCode from 'easyqrcodejs'
import { jsPDF } from 'jspdf'
import ShippingService from '@/services/ShippingService'
import countryLookup from 'country-code-lookup'
// const currencyConverter = {
//   eur: '€',
//   inr: '₹'
// }
const contactNoRegex = helpers.regex('contact_no', /^([+][0-9]{11,12})$/)

export default {
  name: 'firstProductCreateModal',
  components: {
    boardal,
    FAQStripe,
    CategoryCardSlider,
    TaxVerification,
    // SupplierCardSlider,
    DeliveryDetails,
    WholesaleDetails,
    ProductImageUpload
    // ToggleServiceProduct
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL,
      name: '',
      address_no: '',
      address: '',
      building_no: '',
      postal_code: '',
      city: '',
      region: '',
      cascadian_number: null,
      cityNames: [],
      cascadianData: [],
      regionNames: [],
      country: '',
      vat_no: '',
      liable_for_vat: '0',
      website_url: '',
      email_general: '',
      contact_no: '',
      publish_key: '',
      secret_key: '',
      productName: '',
      cebelca_connected: false,
      description: '',
      sellingPrice: '',
      purchasePrice: '',
      minPrice: '',
      maxPrice: '',
      urlReservation: '',
      stock_general: '',
      stock_curr: '',
      unitName: '',
      unitAddress: '',
      errors: null,
      modal: {
        isOpen: false,
        hasMask: true,
        canClickMask: false,
        hasX: false
      },
      step: 1,
      max: 1,
      showDots: true,
      orientation: 'column',
      shippable: false,
      wholesalable: false,
      selectedCurrency: '€',
      screenArray: [
        'companyDetails',
        'companyContactDetails',
        'accomodation',
        'stripeDetails',
        'cebelcaDetails',
        'categoryDetails',
        // 'supplierDetails',
        'addProduct',
        'shippingDetails',
        'wholesaleDetails',
        'addProductImage'
      ],
      xray: 'hidden',
      clientProfileId: 0,
      productCategory: null,
      supplierDetails: {},
      clientId: JSON.parse(localStorage.getItem('user')).id,
      shippingJson: {},
      wholesaleJson: {},
      productId: 0,
      unitId: 0,
      experienceId: 0,
      unitProduct: {},
      validationMessage: 'Please fill all the details',
      isProductFlowEnabled: true,
      experience: {},
      isDataValid: false,
      widget: null
    }
  },
  validations() {
    return {
      name: { required },
      address_no: { required },
      address: { required },
      building_no: { required },
      postal_code: { required },
      city: { required },
      region: { required },
      country: { required },
      vat_no: { required, minLength: minLength(8), maxLength: maxLength(8) },
      liable_for_vat: { required },
      website_url: { url },
      email_general: { required, email },
      contact_no: { required, contactNoRegex },
      secret_key: { required },
      publish_key: { required },
      productName: { required },
      description: { required },
      sellingPrice: { required, decimal },
      purchasePrice: { required, decimal },
      stock_general: { required, numeric },
      stock_curr: {},
      unitName: { required },
      unitAddress: { required },
      minPrice: { required, decimal },
      maxPrice: { required, decimal },
      urlReservation: { required, url }
    }
  },
  computed: {
    isFirstStep: function() {
      return this.step === 1
    },
    isLastStep: function() {
      return this.step === this.max
    },
    hasDots: function() {
      return this.max > 1 && this.showDots
    },
    x_multiplier: function() {
      return this.orientation === 'row' ? -1 : 0
    },
    y_multiplier: function() {
      return this.orientation === 'row' ? 0 : -1
    },
    axis: function() {
      return this.orientation === 'row' ? 'row' : 'column'
    },
    axisReverse: function() {
      return this.orientation === 'row' ? 'row-reverse' : 'column-reverse'
    },
    cross: function() {
      return this.orientation === 'row' ? 'column' : 'row'
    },
    crossReverse: function() {
      return this.orientation === 'row' ? 'column-reverse' : 'row-reverse'
    },
    nextIcon: function() {
      return this.orientation === 'row' ? 'fa-arrow-right' : 'fa-arrow-down'
    },
    backIcon: function() {
      return this.orientation === 'row' ? 'fa-arrow-left' : 'fa-arrow-up'
    }
  },
  watch: {
    orientation: 'setCssVars'
    // xray: 'setCssVars'
  },
  methods: {
    selectType(value) {
      this.isProductFlowEnabled = value
      this.screenArray = this.isProductFlowEnabled
        ? [
            'companyDetails',
            'companyContactDetails',
            'accomodation',
            'stripeDetails',
            'cebelcaDetails',
            'categoryDetails',
            // 'supplierDetails',
            'addProduct',
            'shippingDetails',
            'wholesaleDetails',
            'addProductImage'
          ]
        : [
            'companyDetails',
            'companyContactDetails',
            'stripeDetails',
            'cebelcaDetails',
            'categoryDetails',
            // 'supplierDetails',
            'addExperience',
            'addExperienceImage'
          ]
      const self = this
      setTimeout(function() {
        self.$sections = self.$el.querySelectorAll('section')
        self.max = self.$sections.length
      }, 1)
    },
    selectedSupplier(supplierDetails) {
      this.supplierDetails = supplierDetails
      this.nextClick()
    },
    selectedCategory(categoryDetails) {
      this.productCategory = categoryDetails
      this.nextClick()
    },
    unselectedCategory(categoryDetails) {
      this.productCategory = categoryDetails
      this.isValidData()
    },
    toggleModal: function(step) {
      step = step || 1
      this.modal.isOpen = !this.modal.isOpen
      if (this.modal.isOpen) {
        let self = this
        setTimeout(function() {
          self.$sections = self.$el.querySelectorAll('section')
          self.max = self.$sections.length
          self.goToStep(step)
        }, 1)
      }
    },
    setCssVars: function() {
      this.$el.style.setProperty(
        '--x',
        (this.step * 100 - 100) * this.x_multiplier + '%'
      )
      this.$el.style.setProperty(
        '--y',
        (this.step * 100 - 100) * this.y_multiplier + '%'
      )
      this.$el.style.setProperty('--axis', this.axis)
      this.$el.style.setProperty('--axis-reverse', this.axisReverse)
      this.$el.style.setProperty('--cross', this.cross)
      this.$el.style.setProperty('--cross-reverse', this.crossReverse)
      // this.$el.style.setProperty('--vision', this.xray)
    },
    goToStep: function(step) {
      this.step = step > this.max ? this.max : step < 1 ? 1 : step
      this.currentSection = this.$sections[this.step - 1]
      this.$sections.forEach(function(section) {
        section.classList.remove('current')
      })
      this.currentSection.classList.add('current')
      this.currentSection.scrollTop = 0
      this.setCssVars()
      if (step === 3) {
        this.widget = new window.google.maps.places.Autocomplete(
          document.getElementById('unitAddress'),
          { types: ['geocode'] }
        )

        this.widget.addListener('place_changed', () => {
          this.unitAddress = document.getElementById('unitAddress').value
        })
      }
      if (step === 7) {
        if (this.productCategory === null) {
          alert('Category was not selected. Please select a category')
          this.goToStep(6)
        }
      }
      if (step === 8 || step === 9) {
        if (this.productId === 0) {
          alert('Product is not created. Please create a product')
          this.goToStep(7)
        }
      }
      this.isValidData()
    },
    skip: async function(step) {
      this.step += step
      if (this.screenArray.length === this.step - 1) {
        if (this.isProductFlowEnabled)
          this.unitProduct = await this.$store.dispatch(
            'unitProduct/fetchUnitProduct',
            { unitId: this.unitId, productId: this.productId }
          )
        else {
          this.experience = await this.$store.dispatch(
            'experience/fetchExperienceById',
            this.experienceId
          )
        }
      }
      this.goToStep(this.step)
      this.isValidData()
    },
    async nextClick() {
      // if (await this.isValidData()) {
      await this.saveData()
      if (this.errors === null) {
        this.skip(1)
      }
      // this.isDataValid = false
      // } else {
      // alert(this.validationMessage)
      // }
    },
    async isValidData() {
      let valid = true
      this.validationMessage = 'Please fill all the details'
      switch (this.screenArray[this.step - 1]) {
        case 'companyDetails':
          if (
            !this.name ||
            !this.address ||
            !this.address_no ||
            !this.building_no ||
            !this.postal_code ||
            !this.city ||
            this.city == null ||
            !this.region ||
            this.region == null ||
            !this.country ||
            !this.vat_no
          )
            valid = false
          break
        case 'companyContactDetails':
          if (
            !this.email_general ||
            !this.contact_no ||
            !this.contact_no.match(/^([+][0-9]{11,12})$/)
          )
            valid = false
          break
        case 'stripeDetails':
          if (!this.publish_key || !this.secret_key) valid = false
          break
        case 'cebelcaDetails':
          if (this.cebelca_connected === false) valid = false
          break
        case 'categoryDetails':
          if (!this.productCategory) valid = false
          break
        case 'supplierDetails':
          if (!this.supplierDetails) valid = false
          break
        case 'addProduct':
          if (
            !this.productName ||
            !this.description ||
            !this.purchasePrice ||
            !this.sellingPrice ||
            !this.stock_general
          )
            valid = false
          break
        case 'addExperience':
          if (
            !this.productName ||
            !this.description ||
            !this.minPrice ||
            !this.maxPrice ||
            !this.urlReservation
          )
            valid = false
          break
        case 'shippingDetails':
          if (
            this.shippingJson.shippable &&
            (!this.shippingJson.pkg_weight ||
              !this.shippingJson.pkg_height ||
              !this.shippingJson.pkg_width ||
              !this.shippingJson.pkg_length ||
              !this.shippingJson.pickup_address ||
              !this.shippingJson.pickup_postal_code ||
              !this.shippingJson.pickup_city ||
              !this.shippingJson.pickup_country)
          )
            valid = false
          else {
            valid = true
            if (!valid) {
              this.validationMessage = 'Please enter valid address'
            }
          }
          break
        case 'wholesaleDetails':
          if (
            this.wholesaleJson.wholesalable &&
            (!this.wholesaleJson.wholesale_price ||
              !this.wholesaleJson.sugg_selling_price ||
              !this.wholesaleJson.moq)
          )
            valid = false
          break
        case 'accomodation':
          if (!this.unitName || !this.unitAddress) valid = false
          break
      }
      this.isDataValid = valid
      return valid
    },
    async saveData() {
      this.errors = null
      switch (this.screenArray[this.step - 1]) {
        case 'companyDetails':
          this.saveCompanyDetails()
          break
        case 'companyContactDetails':
          this.saveCompanyContactDetails()
          break
        case 'stripeDetails':
          await this.savePaymentDetails()
          break
        case 'cebelcaDetails':
          await this.completeCebelcaStep()
          break
        case 'categoryDetails':
          this.saveCatagoryDetails()
          break
        case 'supplierDetails':
          this.saveSupplierDetails()
          break
        case 'addProduct':
          await this.addProduct(this.generateProductJson())
          break
        case 'addExperience':
          this.addExperience(this.generateExpereinceJson())
          break
        case 'shippingDetails':
          this.addShippingDetails()
          break
        case 'wholesaleDetails':
          this.addWholesaleDetails()
          break
        case 'accomodation':
          this.addAccomodationDetails()
          break
        case 'addProductImage':
          this.uploadProductImage()
          break
      }
    },
    async saveCompanyDetails() {
      await this.$store.dispatch('client/addClient', {
        name: this.name,
        address_no: this.address_no,
        address: this.address,
        building_no: this.building_no,
        postal_code: this.postal_code,
        city: this.city,
        region: this.region,
        cascadian_number: this.cascadian_number,
        country: this.country,
        vat_no: this.vat_no,
        liable_for_vat: this.liable_for_vat
      })
    },
    async saveCompanyContactDetails() {
      await this.$store.dispatch('client/editClient', {
        id: this.clientId,
        name: this.name,
        address_no: this.address_no,
        address: this.address,
        building_no: this.building_no,
        postal_code: this.postal_code,
        city: this.city,
        region: this.region,
        country: this.country,
        vat_no: this.vat_no,
        liable_for_vat: this.liable_for_vat,
        email_general: this.email_general,
        contact_no: this.contact_no,
        website_url: this.website_url
      })
    },
    async savePaymentDetails() {
      await this.$store
        .dispatch('addKeys', {
          publishable_key: this.publish_key,
          secret_key: this.secret_key
        })
        .then(response => {
          if (
            response.data.flagKeyExists &&
            response.data.flagKeyExists === true
          ) {
            this.errors = this.$t('keyAlreadyExist')
          }
        })
        .catch(err => {
          this.errors = err.response.data.response
        })
    },
    completeCebelcaStep() {
      this.cebelca_connected = true
      this.isValidData()
    },
    saveCatagoryDetails() {},
    saveSupplierDetails() {},
    async addProduct(productJson) {
      this.errors = null
      if (productJson.price < 0.5) {
        this.errors = this.$t('minSellingPrice')
        alert(this.$t('minSellingPrice'))
      } else {
        const productResponse = await this.$store.dispatch(
          'product/createProduct',
          productJson
        )
        this.productId = productResponse.insertId
        await this.$store.dispatch('unitProduct/createUnitProduct', {
          unit: { id: this.unitId },
          product: { id: this.productId },
          stock_curr: this.stock_general
        })
      }
    },
    async addExperience(experienceJson) {
      const experienceResponse = await this.$store.dispatch(
        'experience/upsertExperience',
        experienceJson
      )
      this.experienceId = experienceResponse.id
    },
    generateExpereinceJson() {
      const experience = {
        supplier_id: this.supplierDetails.id,
        client_id: this.clientId,
        expCat_id: this.productCategory.id,
        name: this.productName,
        description: this.description,
        price_min: this.minPrice,
        price_max: this.maxPrice,
        url: this.urlReservation
      }
      return experience
    },
    generateProductJson() {
      const product = {
        supplier: this.supplierDetails,
        client_id: this.clientId,
        prodCat: this.productCategory,
        name: this.productName,
        description: this.description,
        purchase_price: this.purchasePrice,
        price: this.sellingPrice,
        stock_general: this.stock_general,
        is_first_product_creation: true
      }
      return product
    },
    async addShippingDetails() {
      if (this.shippingJson.shippable) {
        delete this.shippingJson.shippable
        await this.$store.dispatch('product/addProductShippingDetails', {
          product_id: this.productId,
          ...this.shippingJson
        })
        await this.$store.dispatch('product/editProduct', {
          id: this.productId,
          shippable: true
        })
      } else {
        await this.$store.dispatch('product/editProduct', {
          id: this.productId,
          ...this.shippingJson
        })
      }
    },
    async addWholesaleDetails() {
      if (this.wholesaleJson.wholesalable) {
        delete this.wholesaleJson.wholesalable
        await this.$store.dispatch('product/addProductWholesaleDetails', {
          product_id: this.productId,
          ...this.wholesaleJson
        })
        await this.$store.dispatch('product/editProduct', {
          id: this.productId,
          wholesalable: true
        })
      } else {
        await this.$store.dispatch('product/editProduct', {
          id: this.productId,
          ...this.wholesaleJson
        })
      }
    },
    async validateAddress() {
      const validationResponse = await ShippingService.getValidateAddress({
        StreetAddress: this.shippingJson.pickup_address,
        City: this.shippingJson.pickup_city,
        PostalCode: this.shippingJson.pickup_postal_code,
        CountryCode: countryLookup.byCountry(this.shippingJson.pickup_country)
          .iso2
      })
      if (validationResponse.data.status === 'VALID') return true
      return false
    },
    async addAccomodationDetails() {
      const unitResponse = await this.$store.dispatch('unit/createUnit', {
        client_id: this.clientId,
        name: this.unitName,
        address: this.unitAddress,
        is_first_product_creation: true
      })
      this.unitId = unitResponse.insertId
    },
    async uploadProductImage() {
      await this.$store.dispatch('unitProduct/copyUnitProductImage', {
        unit_id: this.unitId,
        product_id: this.productId
      })
    },
    reset: function() {
      this.goToStep(1)
    },
    finish: function() {
      this.toggleModal()
      if (this.isLastStep) {
        this.$parent.renderPage()
      }
    },
    saveShippingData(shippingJson) {
      this.shippingJson = shippingJson
      this.isValidData()
    },
    saveWholesaleData(wholesaleJson) {
      this.wholesaleJson = wholesaleJson
      this.isValidData()
    },
    async downloadQRCodePdf() {
      const qrcode = document.getElementById('qrcode')
      let qrCanvas = qrcode.firstChild

      const imgData = qrCanvas.toDataURL('image/png')
      const doc = new jsPDF('p', 'mm', 'a4')

      doc.addImage(imgData, 'PNG', 20, 30, 60, 60)

      const dataUri = await this.convertTextToImage()
      doc.addImage(dataUri, 'PNG', 20, 100)

      doc.save(`QR-Code:${this.unitId}-${this.productId}.pdf`)
    },
    convertTextToImage() {
      return new Promise((resolve, reject) => {
        const textToConvert = `Unit : ${this.unitProduct.unit_name}\nProduct Name : ${this.unitProduct.product_name}\nProduct category : ${this.unitProduct.prodCat_name}`
        this.$store
          .dispatch('unitProduct/convertTextToImage', {
            text: textToConvert
          })
          .then(response => {
            return resolve(response.dataUri)
          })
          .catch(error => {
            return reject(error)
          })
      })
    },
    downloadExperienceQRCodePdf() {
      const qrcode = document.getElementById('qrcode')
      let qrCanvas = qrcode.firstChild

      const imgData = qrCanvas.toDataURL('image/png')
      const doc = new jsPDF('p', 'mm', 'a4')

      doc.text(
        doc.splitTextToSize(
          `${this.baseUrl}/experience/${this.experience.uuid}`,
          180
        ),
        10,
        30
      )

      doc.setFont('Lato-Regular', 'normal')
      doc.addImage(imgData, 'PNG', 30, 40, 100, 100)
      doc.text(`Expereince Name`, 10, 160)
      doc.text(`Expereince Category`, 10, 170)

      doc.setFont('Lato-Regular', 'bold')
      doc.text(`${this.experience.name}`, 60, 160)
      doc.text(`${this.productCategory.name}`, 60, 170)

      doc.save(`QR-Code:${this.experienceId}.pdf`)
    },
    renderQRCode() {
      let options = {
        text: `${this.baseUrl}/unitStore/${this.unitProduct.unit_uuid}/product/${this.unitProduct.product_uuid}`,
        width: 200,
        height: 200,
        logo: '../../../../expar_logo_new.svg',
        dotScale: 0.5,
        PO: '#0c2e44',
        PI: '#fb7377'
      }

      new QRCode(this.$refs.qrcode, options)
    },
    async openQRCodeModal() {
      await this.$bvModal.show('qrcode-modal')
      this.renderQRCode()
    },
    getClientDetails() {
      const user = JSON.parse(localStorage.getItem('user'))
      axios
        .get(`${process.env.VUE_APP_API_URL}/client/` + user.id)
        .then(response => {
          this.clientDetails = response.data
          if (this.clientDetails.name !== null)
            this.name = this.clientDetails.name
          if (this.clientDetails.address_no !== null)
            this.address_no = this.clientDetails.address_no
          if (this.clientDetails.address !== null)
            this.address = this.clientDetails.address
          if (this.clientDetails.building_no !== null)
            this.building_no = this.clientDetails.building_no
          if (this.clientDetails.postal_code !== null)
            this.postal_code = this.clientDetails.postal_code
          if (this.clientDetails.city !== null)
            this.city = this.clientDetails.city
          if (this.clientDetails.region !== null)
            this.region = this.clientDetails.region
          if (this.clientDetails.country !== null)
            this.country = this.clientDetails.country
          if (this.clientDetails.vat_no !== null)
            this.vat_no = this.clientDetails.vat_no
          if (this.clientDetails.liable_for_vat !== null)
            this.liable_for_vat = this.clientDetails.liable_for_vat.toString()

          if (this.clientDetails.email_general !== null)
            this.email_general = this.clientDetails.email_general
          if (this.clientDetails.contact_no !== null)
            this.contact_no = this.clientDetails.contact_no
          if (this.clientDetails.website_url !== null)
            this.website_url = this.clientDetails.website_url

          if (this.clientDetails.publishable_key !== null)
            this.publish_key = this.clientDetails.publishable_key
          if (this.clientDetails.secret_key !== null)
            this.secret_key = this.clientDetails.secret_key
        })
    },
    async changeCity() {
      this.isValidData()
      this.region = null
      const cityJson = {
        lang: this.$i18n.locale,
        city: this.city
      }
      this.cascadianData = await this.$store.dispatch(
        'client/fetchCascadianRegion',
        cityJson
      )
      this.regionNames = this.cascadianData.map(a => a.municipality)
      this.isValidData()
    },
    changeRegion() {
      this.isValidData()
      if (this.region !== null) {
        const selectedCascadian = this.cascadianData.filter(data => {
          return data.municipality === this.region
        })
        this.cascadian_number = selectedCascadian[0].cascadian_number
      }
      this.isValidData()
    }
  },
  async mounted() {
    this.getClientDetails()
    this.cityNames = await this.$store.dispatch(
      'client/fetchCascadianCityList',
      this.$i18n.locale
    )
  }
}
</script>

<style lang="scss" scoped>
:root {
  --accent: red !important; //not working//
}

/* tab setting */
$tab-count: 4;
$indicator-width: 50px;
$indicator-height: 4px;
/* breakpoints */
$breakpoints: (
  medium: #{$tab-count * 250px},
  small: #{$tab-count * 150px}
);

.errorBg {
  // background-color: var(--primarySuperLight) !important;
  // border-color: none;
  border: 2px solid var(--primaryDark) !important;
  // border-bottom: 0.2px solid var(--primary);
}

.close-btn {
  position: absolute;
  left: 10px;
}

.trash-btn {
  background: var(--bg-light);
  color: var(--bright) !important;
  padding: 15px;
  letter-spacing: 3px;
  border: none !important;
  border-radius: 7px;
  margin: auto;
  width: 15em;
  height: auto;
  margin-left: 20px;
  cursor: pointer;
}
.trash-btn:hover {
  text-decoration: none !important;
}

.trash-btn1 {
  background: var(--bg-light);
  color: var(--bright) !important;
  padding: 15px;
  letter-spacing: 3px;
  border: none !important;
  border-radius: 7px;
  margin: auto;
  width: 15em;
  height: auto;
  cursor: pointer;
}
.trash-btn1:hover {
  text-decoration: none !important;
}

.optional {
  padding-bottom: 5px;
  align-self: flex-end;
  color: var(--grey);
  font-size: 0.9em;
}

.img-wrapper {
  width: auto;
  position: relative;
}
.img-wrapper > img {
  position: relative;
}
.about-img {
  display: inline-block;
  width: 100%;
  max-width: 300px;
  text-align: center;
  vertical-align: top;
}
.about-img2 {
  display: inline-block;
  width: 100%;
  max-width: 500px;
  text-align: center;
  vertical-align: top;
}
.about-img img {
  width: 100%;
}
.selectCountry {
  margin-bottom: 0;
}

.questionMark {
  color: var(--bright) !important;
  border-radius: 50% !important;
  border: none;
  background-color: var(--bg) !important;
  padding: 3px 7px !important;
  margin-left: 5px !important;
  margin-right: 3px !important;
}

.marginBottom {
  margin-bottom: 5px;
}

.questionMark:hover {
  background-color: var(--primaryDark) !important;
}

.questionMarkLeft:hover {
  background-color: var(--primaryDark) !important;
}

.login-btn {
  color: var(--bright) !important;
  border: none;
  background: var(--primaryDark);
  text-decoration: none;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 2px;
  padding: 15px 20px;
  border-radius: 5px;
  transition: 0.3s;
  transition-property: background;
}

.login-btn:hover {
  background: var(--primary);
  color: var(--bright) !important;
}

.feature {
  margin-bottom: 10px;
}

#qrcode-modal .modal-header {
  border-bottom: none !important;
}

.large {
  font-weight: 600;
}
.price-wrapper {
  display: flex;
}

.price-wrapper span {
  font-weight: 600;
  font-size: 1.3em;
  margin-left: 5px;
  color: var(--bg);
}
.stockInput span {
  font-weight: 600;
  font-size: 1em;
  margin-left: 5px;
  color: var(--bg);
}

.field {
  width: 100%;
}
.fieldPrice {
  width: 30%;
}

.fieldPrice2 {
  //   width: 80%;
  margin: 0px;
  padding: 0px !important;
}
.fieldZipCode {
  width: 60%;
  height: 31px;
  margin: 0px 25px 0px 0px;
}
.fieldTagline {
  width: 60%;
  margin: auto;
}

.about-text {
  display: inline-block;
  max-width: 450px;
  text-align: left;
  margin-top: 5px;
  margin-left: 50px;
  padding: 5px;
  margin: 5px;
  line-height: 0.8;
  h5 h6 {
    font-weight: 600;
  }
}

.about-text textarea::placeholder {
  font-size: 0.9rem;
}

.inp {
  border: none;
  border-bottom: 0.2px solid var(--bg);
  padding: 5px 10px;
  outline: none;
  margin-bottom: 1.2em;
  background-color: var(--grey-superlight);
}
.inp:hover {
  border-color: var(--primary);
}

[placeholder]:focus::-webkit-input-placeholder {
  transition: text-indent 0.4s 0.4s ease;
  text-indent: -100%;
  opacity: 1;
}

[v-cloak] {
  display: none;
}

.sm {
  font-size: 0.85em;
}

.xs {
  font-size: 0.75em;
}

.errorMessage {
  font-size: 0.8em;
  line-height: 0.8rem;
  margin-top: -10px;
  color: var(--primaryDark);
}

// modal content sliders
article {
  flex: 1 1 100%;
  height: 100%;
  display: flex;
  flex-direction: var(--axis, row);
  overflow: hidden;
}
section {
  width: 100%;
  visibility: hidden;
  flex: 0 0 100%;
  padding: 1em;
  overflow: auto;
  will-change: transform;
  transform: translate(var(--x, 0%), var(--y, 0%));
  transition: transform 300ms ease-out;
  position: relative;
  h2,
  h3,
  h4 {
    margin-top: 0;
  }
  &.current {
    visibility: visible;
  }
}

section h3 {
  margin-top: 1.5em;
  font-size: 1.5rem;
  font-weight: 600;
}

section label {
  color: var(--bg-light);
  font-weight: 600;
}
section .inputForm {
  font-size: 0.8em !important;
}

footer {
  position: relative;
  text-align: right;
  display: flex;
  flex-direction: var(--axis-reverse, row-reverse);
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 0 0 1px rgba(#000, 0.1);
  background: rgba(#000, 0.05);
  &:not(:empty) {
    padding: 0.5em;
  }
}

.step-dots {
  display: flex;
  flex-direction: var(--axis, row);
}
.step-dot {
  cursor: pointer;
  width: 1em;
  height: 1em;
  margin: 0.5ch;
  border-radius: 1em;
  background: currentColor;
  opacity: 0.2;
  transition: transform 100ms ease-out, opacity 150ms linear;
  &.active {
    opacity: 0.7;
    box-shadow: 0 0 1em -0.25em;
  }
  &:hover {
    transform: scale(1.2);
  }
}
.forward-actions,
.back-actions {
  flex: 1;
  display: flex;
  flex-direction: var(--axis, row);
}
.forward-actions {
  justify-content: flex-end;
  // text-align: right;
}
.back-actions {
  justify-content: flex-start;
  // text-align: left;
}

.finishBtn {
  width: auto !important;
  margin-top: 15px;
}

// boring
*,
*::before,
*::after {
  box-sizing: border-box;
}

a {
  color: var(--accent);
}

del {
  color: #ca1e34;
  font-style: italic;
}

p {
  line-height: 1.5;
}

body {
  margin: 0;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: sans-serif;
  background: snow;
  color: #333;
}

// broadal buttons
button {
  outline: none;
  font: inherit;
  line-height: 1;
  cursor: pointer;
  padding: 0.5em 1em;
  border-radius: 0.35em;
  color: rgba(#000, 0.7);
  background: rgba(#000, 0.1);
  border: 2px solid rgba(#000, 0.05);
  text-shadow: 0 1px 0 rgba(#fff, 0.4);
  transition: transform 50ms ease-out;
  will-change: transform;
  &:active {
    transform: scale(0.95);
  }
  &:focus {
    border-color: var(--accent);
    box-shadow: 0 0 1em 0 var(--accent);
  }
  &[disabled] {
    opacity: 0.2;
    cursor: not-allowed;
  }
  &.primary {
    border-color: transparent;
    background: transparent;
    font-weight: bold;
    &:not([disabled]) {
      color: var(--accent);
    }
  }
  &.accent {
    background: var(--accent);
    &:not([disabled]) {
      color: #fff;
    }
  }
  &.secondary {
    border-color: transparent;
    background: transparent;
    &:not([disabled]) {
      color: rgba(#000, 0.4);
    }
  }
  &.cancel:not([disabled]) {
    color: var(--accent);
  }
}

@media (max-width: map-get($breakpoints, small)) {
  section h3 {
    font-size: 1.1rem !important;
  }
  .about-container {
    text-align: left;
  }
  .about-img {
    padding: 0em;
    margin: 5px;
    vertical-align: top;
    max-width: 170px;
  }
  .about-text {
    display: inline-block;
    /* max-width: 400px; */
    text-align: left;
    line-height: 0.5;
    font-size: 0.8em;
    width: 100%;
  }
  .about-text textarea {
    font-size: 0.8em;
    line-height: 1.2em;
  }
  .about-text textarea::placeholder {
    font-size: 0.7rem;
  }
  .about-text span {
    letter-spacing: normal;
  }

  .finishBtn {
    width: auto;
    margin-top: 15px;
  }

  .feature {
    margin-bottom: 1px;
  }
  .fieldTagline {
    width: 95%;
  }
  .accent {
    width: 80%;
  }
  section h3 {
    font-size: 1.35rem;
    margin-top: 1.6em;
  }
  section label {
    line-height: 1.2em;
  }
  .price-wrapper {
    display: block;
  }
  .fieldPrice {
    width: 30% !important;
    // margin: 10px 0px;
  }
  .form-control2 {
    font-size: 0.7rem !important;
  }
  .sm-img {
    width: 70% !important;
  }
  .trash-btn {
    width: auto;
    margin: 0;
    height: auto;
  }
  .trash-btn1 {
    width: auto;
    margin: 0;
    height: auto;
  }
}

@media (min-width: map-get($breakpoints, small)) {
  .about-container {
    text-align: center;
  }
  .text-wrapper {
    display: flex;
    position: absolute;
    left: 20%;
  }
  .hideDesktop {
    display: none;
  }
}

@media only screen and (max-device-width: 900px) and (orientation: landscape) {
  .trash-btn {
    padding: 2px;
    width: 150px;
  }
}
</style>
